import { NgModule } from '@angular/core';
import { HttpService } from './http.service';
import { UtilService } from './util.service';


@NgModule({
  providers: [ HttpService, UtilService]
})
export class ServicesModule { }
